// const newsletter__wrapper = document.querySelector('.newsletter__popup__wrapper');
// const close__newsletter__popup = document.querySelector('.close__newsletter__popup svg');

// function showPopup() {
//     newsletter__wrapper.classList.add('active');
// }
// setTimeout(showPopup, 8000);



// close__newsletter__popup.addEventListener('click', () => {
//     newsletter__wrapper.classList.remove('active');
//   });